<template>
  <div id="app">
    <div class="invitationRules" v-html="content"></div>
  </div>
</template>

<script>
  import axios from 'axios'
  import '@/assets/css/style.css'
  export default {
    data() {
      return {
        content: ''
      }
    },
    created: function() {
      document.title = this.$t('column.invitation_rules')
      this.getinvitation()
    },
    methods: {
      getinvitation() {
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=invite_vue&act=reward_rules&token="+token)
          .then(res => {
            console.log("数据：", res);
            if (res.data.status) {
              this.content = res.data.data.content
            }
          }).catch((res) => {
          console.log("请求失败");
        })
      },
    }
  }
</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/invitationRules.vue